import { render, staticRenderFns } from "./CampaignListTable.vue?vue&type=template&id=42a303f6&scoped=true"
import script from "./CampaignListTable.vue?vue&type=script&lang=js"
export * from "./CampaignListTable.vue?vue&type=script&lang=js"
import style0 from "./CampaignListTable.vue?vue&type=style&index=0&id=42a303f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a303f6",
  null
  
)

export default component.exports